// ✅ CORRECT: Import from centralized types
import type { AuditFilters, AuditTrailResponse } from "../types";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

export function useAuditTrail(filters: AuditFilters) {
  return useQuery({
    queryKey: ["audit-trail", filters],
    queryFn: async (): Promise<AuditTrailResponse> => {
      // Following established edge function call pattern
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session?.access_token) {
        throw new Error("Sessão de autenticação não encontrada");
      }

      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, value.toString());
        }
      });

      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
      const response = await fetch(
        `${supabaseUrl}/functions/v1/audit-logs?${params}`,
        {
          headers: {
            Authorization: `Bearer ${session.access_token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || "Falha ao carregar trilha de auditoria"
        );
      }

      return response.json();
    },
    staleTime: 30 * 1000, // 30 seconds (following established pattern)
  });
}
